import { createReducer } from 'reduxsauce';
import { APP_TOUR, CURRENT_USER } from 'actions/Base';
import { getValuesFromTourBitmask } from 'utils/helpers.js'


export const INITIAL_STATE = {
  status: {
    companyProfile: true,
    hitManager: true,
    hitSearch: true,
    addReqProfile: true
  },
};

export const onGetStatusSuccess = (state, { payload }) => {

  // console.log('payload.takenTours', payload.takenTours)

  const newStatus = getValuesFromTourBitmask(payload.takenTours);

  // console.log('newStatus', newStatus)

  return { ...state, status: newStatus }

}

export const onSaveStatusRequest = (state) => ({ ...state });
export const onSaveStatusFailure = (state) => ({ ...state });
export const onSaveStatusSuccess = (state, { payload }) => {

  switch (payload.key) {
    case "companyProfile" : return { ...state, status: { ...state.status, companyProfile: payload.value } }
    case "hitManager" : return { ...state, status: { ...state.status, hitManager: payload.value } }
    case "hitSearch" : return { ...state, status: { ...state.status, hitSearch: payload.value } }
    case "addReqProfile" : return { ...state, status: { ...state.status, addReqProfile: payload.value } }
    default: return state
  }
  
};


export const onResetRequest = () => INITIAL_STATE;

export const ACTION_HANDLERS = {
  [CURRENT_USER.GET_SUCCESS]: onGetStatusSuccess,
  // [APP_TOUR.SAVE_STATUS_REQUEST]: onSaveStatusRequest,
  [APP_TOUR.SAVE_STATUS_SUCCESS]: onSaveStatusSuccess,
  // [APP_TOUR.RESET_REQUEST]: onResetRequest,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
